<!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
<div class="lbd-backdrop" data-testid="live-bug-backdrop" (click)="dismissFromBackdrop()">
  <div
    class="lbd-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="lbd-title"
    data-testid="live-bug-dialog"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    (click)="$event.stopPropagation()"
    (keydown.escape)="cancel()"
  >
    <to-section-title headingId="lbd-title" [title]="keys.title | translate" [subtitle]="subtitle()">
      <button
        right
        type="button"
        class="lbd__close"
        data-testid="live-bug-close"
        [attr.aria-label]="keys.close | translate"
        [disabled]="submitting()"
        (click)="cancel()"
      >
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </to-section-title>

    <div class="lbd__body">
      <label class="lbd__legend" for="lbd-subject">{{ keys.subjectLabel | translate }}</label>
      <input
        #subjectField
        id="lbd-subject"
        class="lbd__field"
        type="text"
        data-testid="live-bug-subject"
        cdkFocusInitial
        required
        aria-required="true"
        [attr.maxlength]="fieldLengths.NAME_MAX"
        [disabled]="submitting()"
        [value]="subject()"
        (input)="subject.set(subjectField.value)"
      />

      <label class="lbd__legend" for="lbd-description">{{ keys.descriptionLabel | translate }}</label>
      <textarea
        #descriptionField
        id="lbd-description"
        class="lbd__field lbd__field--text"
        rows="5"
        data-testid="live-bug-description"
        [attr.aria-describedby]="ausfuehrung() ? 'lbd-anhang-hint' : previewArea() ? 'lbd-preview-area' : null"
        [attr.maxlength]="fieldLengths.FREETEXT_MAX"
        [disabled]="submitting()"
        [value]="description()"
        (input)="description.set(descriptionField.value)"
      ></textarea>
      <div class="lbd__below">
        @if (ausfuehrung(); as ausfuehrung) {
          <p class="lbd__hint" id="lbd-anhang-hint" data-testid="live-bug-anhang-hint">
            <mat-icon aria-hidden="true">info</mat-icon>
            {{ (ausfuehrung.anhang ? keys.anhangHinweis : keys.anhangHinweisOhneVorschau) | translate }}
          </p>
        }
        <p class="lbd__counter" data-testid="live-bug-description-counter" aria-live="polite">
          {{ description().length }} / {{ fieldLengths.FREETEXT_MAX }}
        </p>
      </div>

      @if (ausfuehrung()?.anhang; as anhang) {
        <pre class="lbd__anhang" data-testid="live-bug-anhang">{{ anhang }}</pre>
      }

      @if (previewArea(); as area) {
        <section
          class="lbd__preview-area"
          id="lbd-preview-area"
          aria-labelledby="lbd-preview-label"
          data-testid="live-bug-preview-area"
        >
          <h3 class="lbd__legend" id="lbd-preview-label">{{ keys.previewLabel | translate }}</h3>
          @switch (area.status) {
            @case ('loading') {
              <p class="lbd__preview-status" role="status" data-testid="live-bug-preview-status">
                <mat-spinner diameter="14" />
                {{ keys.previewLoading | translate }}
              </p>
            }
            @case ('failed') {
              <p class="lbd__preview-status lbd__preview-failed" role="status" data-testid="live-bug-preview-status">
                <mat-icon aria-hidden="true">error_outline</mat-icon>
                {{ keys.previewFailed | translate }}
              </p>
            }
            @default {
              <pre
                class="lbd__preview"
                tabindex="0"
                role="region"
                aria-labelledby="lbd-preview-label"
                data-testid="live-bug-preview"
                >{{ area.text }}</pre
              >
            }
          }
        </section>
      }

      <div class="lbd__target">
        @if (offersTargetChoice()) {
          <span class="lbd__target-label">{{ keys.targetLabel | translate }}</span>
        }
        <app-bug-target-picker [targets]="targets()" [locked]="submitting()" [(choice)]="choice" />
      </div>

      @if (existingBugKey(); as bugKey) {
        <p class="lbd__existing" role="status" data-testid="live-bug-existing">
          {{ existingKey() | translate }}
          <a
            data-testid="live-bug-existing-link"
            target="_blank"
            rel="noopener noreferrer"
            [href]="existingBugUrl()"
            [attr.aria-label]="keys.existingAria | translate: { key: bugKey }"
          >
            {{ bugKey }}
            <mat-icon aria-hidden="true">open_in_new</mat-icon>
          </a>
        </p>
      } @else if (error(); as failure) {
        <p class="lbd__error" role="alert" data-testid="live-bug-error">
          <mat-icon aria-hidden="true">error_outline</mat-icon>
          <span>{{ errorKey() ?? failure.key | translate: failure.params }}</span>
          @if (failure.showsAccountLink) {
            <a data-testid="live-bug-error-account" routerLink="/account" target="_blank" rel="noopener noreferrer">
              {{ keys.toAccount | translate }}
            </a>
          }
        </p>
      }
    </div>

    <div class="lbd__actions">
      <button
        type="button"
        class="lbd__btn lbd__btn--ghost"
        data-testid="live-bug-cancel"
        [disabled]="submitting()"
        (click)="cancel()"
      >
        {{ keys.cancel | translate }}
      </button>
      <button
        type="button"
        class="lbd__btn lbd__btn--primary"
        data-testid="live-bug-submit"
        [disabled]="!canSubmit()"
        (click)="submit()"
      >
        @if (submitting()) {
          <mat-spinner diameter="16" />
        } @else {
          <mat-icon aria-hidden="true">add</mat-icon>
        }
        {{ keys.submit | translate }}
      </button>
    </div>
  </div>
</div>
